import { render, staticRenderFns } from "./signUpPage.vue?vue&type=template&id=6f4a55e2&scoped=true&"
import script from "./signUpPage.vue?vue&type=script&lang=js&"
export * from "./signUpPage.vue?vue&type=script&lang=js&"
import style0 from "./signUpPage.vue?vue&type=style&index=0&id=6f4a55e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a55e2",
  null
  
)

export default component.exports